import { render, staticRenderFns } from "./Hcconsulta.vue?vue&type=template&id=16c4a8a6"
import script from "./Hcconsulta.vue?vue&type=script&lang=js"
export * from "./Hcconsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports